import { useFeatureStore } from '@/stores/featureStore';
import { useUserStore } from '@/stores/user';
import { INACTIVITY_LIMIT } from '@/utils/constant';

export let logoutTimer: NodeJS.Timeout | null = null;

const featureStore = useFeatureStore.getState();
const userStore = useUserStore.getState();

export const logoutUser = () => {
  userStore.setInactivityTimeout(true);
  userStore.reset();
  featureStore.reset();
};

export const resetLogoutTimer = () => {
  if (logoutTimer) {
    clearTimeout(logoutTimer);
  }
  logoutTimer = setTimeout(() => {
    logoutUser();
  }, INACTIVITY_LIMIT);
};
